import {createAction, props} from '@ngrx/store';
import {StudySnapshotDTO} from '../dto/study-snapshot';


export const loadSnapshot = createAction(
  '[Snapshot] Load Snapshot',
  props<{ projectId: number; paperId: number }>()
);

export const loadSnapshotSuccess = createAction(
  '[Snapshot] Load Snapshot Success',
  props<{ snapshot: StudySnapshotDTO }>()
);

export const loadSnapshotFailure = createAction(
  '[Snapshot] Load Snapshot Failure',
  props<{ error: any }>()
);
